import { TResponsiblePersonBlockFormProps } from '~/modules/remote-banking-contacts/type.ts';
import { styles } from '~/modules/styles.ts';
import { InformationBlockForm } from '~/modules/remote-banking-contacts/components/InformationBlockForm.tsx';
import { Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FormPhoneField } from '~/components/FormComponents/FormPhoneField.tsx';
import { PersonRole } from '~/modules/remote-banking-contacts/constants.tsx';

export const ResponsiblePersonBlockForm = ({
  parameterValue,
  index,
}: TResponsiblePersonBlockFormProps) => {
  const director =
    parameterValue?.personRole === PersonRole.DIRECTOR ||
    parameterValue?.personRole === PersonRole.SOLE_TRADER;

  const documentNumber = parameterValue?.documentInfo?.documentNumber;
  const documentSeries = parameterValue?.documentInfo?.documentSeries;
  const hasPersonalIdentifier = Boolean(parameterValue?.personalIdentifier);

  const personalInfoName = hasPersonalIdentifier
    ? `formPersons.${index}.personalIdentifier`
    : `formPersons.${index}.documentInfo.documentNumber`;

  const documentInfo = hasPersonalIdentifier
    ? parameterValue.personalIdentifier
    : `${documentSeries ?? ''}${documentNumber ?? ''}`;

  return (
    <Grid container spacing={2} sx={styles.cardForm}>
      <InformationBlockForm baseName={`formPersons.${index}`} disabled />
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          fullWidth
          disabled
          name={personalInfoName}
          value={documentInfo}
          label="РНОКПП/паспорт/інший документ"
          placeholder="Введіть РНОКПП/паспорт/інший документ"
        />
      </Grid>
      <Grid size={{ xs: 0, sm: 6 }} />
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormPhoneField
          allowedCountries={['UA']}
          name={`formPersons.${index}.phoneNumber`}
          label="Номер контактного телефону"
          disabled={director}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          fullWidth
          disabled={director}
          name={`formPersons.${index}.email`}
          label="Адреса електронної пошти"
          placeholder="Введіть адресу електронної пошти"
        />
      </Grid>
    </Grid>
  );
};
